import { FieldSchema } from "../../../Schema";

export const id: FieldSchema = {
  name: "id",
  dataTransform: {
    toDb: undefined,
  },
  display: {
    displayed: false
  },
  form: {
    label: "ID",
    disabled: true,
    displayed: false
  },
};
